var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.58252H5C2.25 0.58252 0 2.88539 0 5.70002V6.97939C0 7.74702 0.5 8.25877 1.25 8.25877H28.75C29.5 8.25877 30 7.74702 30 6.97939V5.70002C30 2.88539 27.75 0.58252 25 0.58252Z",
    fill: "#031B76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 10.8176H1.25C0.5 10.8176 0 11.3294 0 12.097V18.4939C0 21.3085 2.25 23.6114 5 23.6114H25C27.75 23.6114 30 21.3085 30 18.4939V12.097C30 11.3294 29.5 10.8176 28.75 10.8176ZM13.75 19.7732H6.25C5.5 19.7732 5 19.2615 5 18.4939C5 17.7262 5.5 17.2145 6.25 17.2145H13.75C14.5 17.2145 15 17.7262 15 18.4939C15 19.2615 14.5 19.7732 13.75 19.7732ZM23.75 15.9351H21.25C20.5 15.9351 20 15.4234 20 14.6558C20 13.8881 20.5 13.3764 21.25 13.3764H23.75C24.5 13.3764 25 13.8881 25 14.6558C25 15.4234 24.5 15.9351 23.75 15.9351Z",
    fill: "#031B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV4);
export default __webpack_public_path__ + "static/media/v4.bbea4d4f9b2d60cf512a091e15c22579.svg";
export { ForwardRef as ReactComponent };